import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import InputField from "../common/InputField";
import GlobalDropDown from "../common/GlobalDropDown";

// import OtherDropDown from "./GlobalDropDown";
import Otherdropdown from "../AdminModule/Dashboard/AdminDashboard/GlobalDropDown";

// import  cities  from "country-state-city";
import csc from "country-state-city";

import { contactSubmitData } from "./dependencies/action";
import { initGA, logPageView } from "../../analytics";
import FormValidator from "./FormValidator";

import { useHistory } from "react-router-dom";
import { color } from "@mui/system";
import Select, { components, DropdownIndicatorProps } from "react-select";

const defaultFormData = {
  entity_type: "",
  entity_name: "",
  user_name: "",
  contact_number: "",
  email_id: "",
  location_state: "",
  location_city: "",
  user_type: "",
  query_type: "",
  message: "",
  state: "",
  city: "",
  message: "",
};

// const usertypeOptions = [
//   {
//     isoCode: "Mentor",
//     name: "Mentor",
//   },

//   {
//     isoCode: "Startup",
//     name: "Startup",
//   },
//   {
//     isoCode: "Cohort-Based Program Partner",
//     name: "Cohort-Based Program Partner",
//   },
//   {
//     isoCode: "Other",
//     name: "Other",
//   },
// ];

const usertypeOptions = [
  {
    value: "Mentor",
    label: "Mentor",
  },

  {
    value: "Startup",
    label: "Startup",
  },
  {
    value: "Cohort-Based Program Partner",
    label: "Cohort-Based Program Partner",
  },
  {
    value: "Other",
    label: "Other",
  },
];

// const queryOptions = [
//   {
//     isoCode: "TECHNICAL ISSUE",
//     name: "TECHNICAL ISSUE",
//   },
//   {
//     isoCode: "APPLICATION ISSUE",
//     name: "APPLICATION ISSUE",
//   },

//   {
//     isoCode: "ISSUE WITH SPECIFIC MENTOR OR STARTUP",
//     name: "ISSUE WITH SPECIFIC MENTOR OR STARTUP",
//   },
//   {
//     isoCode: "NON-RESPONSE TO CONNECTION REQUEST",
//     name: "NON-RESPONSE TO CONNECTION REQUEST",
//   },
//   {
//     isoCode: "ISSUE WITH COHORT-BASED PROGRAM",
//     name: "ISSUE WITH COHORT-BASED PROGRAM",
//   },
//   {
//     isoCode: "FEEDBACK TO PROGRAM",
//     name: "FEEDBACK TO PROGRAM",
//   },
//   {
//     isoCode: "OTHER",
//     name: "OTHER",
//   },
// ];

const queryOptions = [
  {
    value: "TECHNICAL ISSUE",
    label: "TECHNICAL ISSUE",
  },
  {
    value: "APPLICATION ISSUE",
    label: "APPLICATION ISSUE",
  },

  {
    value: "ISSUE WITH SPECIFIC MENTOR OR STARTUP",
    label: "ISSUE WITH SPECIFIC MENTOR OR STARTUP",
  },
  {
    value: "NON-RESPONSE TO CONNECTION REQUEST",
    label: "NON-RESPONSE TO CONNECTION REQUEST",
  },
  {
    value: "ISSUE WITH COHORT-BASED PROGRAM",
    label: "ISSUE WITH COHORT-BASED PROGRAM",
  },
  {
    value: "FEEDBACK TO PROGRAM",
    label: "FEEDBACK TO PROGRAM",
  },
  {
    value: "OTHER",
    label: "OTHER",
  },
];
const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    paddingLeft: "10px",
    height: "50px",
    borderRadius: "var(--curve10)",
    color: "#333",
    border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
};
const customStyles = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
};

function ContactUs(props) {
  const { t } = useTranslation();
  const newStateArray = [];
  const newCityArray = [];

  const history = useHistory();
  const [fullName, setFullName] = useState("");
  const [selectState, setSelectState] = useState("");
  const [selectCity, setSelectCity] = useState("");
  const [entityType, setEntityType] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [error, setError] = useState({});
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const [wordLimit, setWordlimit] = useState();
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the Description of program"
  );
  const [buttonText, setButtonText] = useState();
  const [selectedState, setSelectedState] = useState(formData.state.value);

  const { contactSubmitData, contactData } = props;

  useEffect(() => {
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);

      // setNewStateOptions(newStateArray);
    });

    // City.getCitiesOfState("IN", selectedState).map(
    //   (item) => {
    //     const newObject = {
    //       value: item.isoCode,
    //       label: item.name,
    //     };

    //     newCityArray.push(newObject);
    //
    //     // setNewCityOptions(newCityArray);
    //   }
    // );
  }, []);
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("Please Enter Query Description");
    } else if (value == 0) {
      SetErrorVisible7(true);
      // document.getElementById("mentoratstartup").value = "";
    } else if (value == 251) {
      setWordCounter(100);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const newStateOptionfunc = (state) => {
    City.getCitiesOfState("IN", state).map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCityArray.push(newObject);

      setNewCityOptions(newCityArray);
    });
  };

  useEffect(() => {
    //
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCityOptions, setNewCityOptions] = useState(null);

  // entity_type: entityType,
  // entity_name: formData.entity_name,
  // user_name: "",
  // contact_number: formData.contact_number,
  // email_id: formData.email_id,
  // location_state: selectState,
  // location_city: selectCity,
  // query_type: buttonText,
  // message: formData.message,

  const validateStep1 = () => {
    const {
      entity_name,
      contact_number,
      email_id,
      state,
      city,
      user_type,
      query_type,
      message,
    } = formData;
    // let params={(

    // )}
    const formStatus = FormValidator.validateStep1({
      entity_name,
      contact_number,
      email_id,
      state,
      city,
      user_type,
      query_type,
      message,
    });

    const errors = {
      entity_name: formStatus.entity_name,
      contact_number: formStatus.contact_number,
      email_id: formStatus.email_id,
      state: formStatus.state,
      city: formStatus.city,
      user_type: formStatus.user_type,
      query_type: formStatus.query_type,
      message: formStatus.message,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };

  const onBlur = () => {
    validateStep1();
  };
  const paragraphOption = useRef();
  const paragraphOption2 = useRef();
  const paragraphOption3 = useRef();
  const paragraphOption4 = useRef();
  const paragraphOption5 = useRef();
  const paragraphOption6 = useRef();
  const paragraphOption7 = useRef();
  const cityInput = useRef();

  // useEffect(() => {
  //   let params = {
  //     sortKey: "name",
  //     sortOrder: "ASC",
  //     // state: "", // optional
  //     // industry: formData.industry, // optional
  //     // function: formData.function, // optional
  //     // stage: formData.stage, // optional
  //     // status: selectedStatus,
  //   };
  //   contactSubmitData(params);
  //   //
  // }, []);

  const handleInputChange = (e) => {
    // alert("test")

    const { value, name } = e.target;

    setFormData((user) => {
      return { ...user, [name]: value };
    });
    // validateStep1Input()
  };
  const resetForm = () => {
    let reset = {
      entity_type: "",
      entity_name: "",
      user_name: "",
      contact_number: "",
      email_id: "",
      location_state: "",
      location_city: "",
      user_type: "",
      query_type: "",
      message: "",
      state: "",
      city: "",
      message: "",
    };
    setFormData(reset);
  };
  const renderErrorMessage = (name) => {
    return (
      <div style={{ paddingLeft: "10px" }}>
        <div className="login-error-msg">{name}</div>
      </div>
    );
  };
  const submitContactForm = () => {
    // const form_Data = new FormData();
    // let params = {
    //   entity_type: entityType,
    // };

    if (!validateStep1()) {
      setHasInvalidSubmitOccurred(true);
    } else {
      // contactSubmitData(formData);

      // const contactapplication = {
      //   entity_type: entityType,
      //   entity_name: formData.entity_name,
      //   user_name: "",
      //   contact_number: formData.contact_number,
      //   email_id: formData.email_id,
      //   location_state: fullName,
      //   location_city: selectCity,
      //   user_type: entityType,
      //   query_type: buttonText,
      //   message: formData.message,
      // };
      const contactapplication = {
        entity_type: entityType,
        entity_name: formData.entity_name,
        user_name: "",
        contact_number: formData.contact_number,
        email_id: formData.email_id,
        location_state: formData.state.value,
        location_city: formData.city.value,
        user_type: formData.user_type.value,
        query_type: formData.query_type.value,
        message: formData.message,
      };

      // form_Data.append(
      //   "application",
      //   JSON.stringify(contactapplication)

      // );
      // contactSubmitData(params);

      contactSubmitData(contactapplication).then((res) => {
        if (res) {
          if (res) {
            history.push({
              pathname: "/contactus",
            });
            // onCloseBothModal();
            // onClose();
            //
          }
        }
      });
      resetForm();
    }
    // contactSubmitData(form_Data);
  };

  return (
    <section
      className="contact-page"
      style={{
        background: "url(assets/images/contact-bg.jpg)",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      id="banner"
    >
      <div className="w-100  pb-50 position-relative contact-data-page">
        <div className="container">
          <form action="#" method="post" id="contact-form">
            <div className="row">
              {/* <div class="col-md-1 col-sm-12 col-lg-1"> </div> */}
              <div className="col-md-8 col-sm-12 col-lg-8">
                <div className="resource-content">
                  <h2 className="mb-0 homepageFirstHeader">
                    {t("CONTACT")}
                    {/* Contact */}
                  </h2>
                  {/* <br />
                  <p>
                    <button className="query-btn">QUERY FORM</button> Feedback
                    will be reviewed by the concerned team to investigate and
                    resolve the matter.
                  </p> */}
                </div>
                <div className="form-group w-100">
                  <div className="response w-100" />
                </div>
                <div className="row mrg10">
                  <div className="col-md-12 col-sm-6 col-lg-12">
                    <div className="field-box w-100">
                      <input
                        className="name homepageFirstDescription"
                        type="text"
                        name="entity_name"
                        placeholder="NAME *"
                        id="entity_name"
                        required
                        value={formData.entity_name}
                        onChange={handleInputChange}
                        // error={error.entity_name}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.entity_name &&
                        renderErrorMessage(error.entity_name)}
                      {/* <InputField
                        required={true}
                        id="entity_name"
                        label="NAME"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={handleInputChange}
                        value={formData.entity_name}
                        name="entity_name"
                        error={error.entity_name}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6 col-lg-12">
                    <div className="field-box w-100">
                      <input
                        className="email homepageFirstDescription"
                        type="email"
                        name="email_id"
                        placeholder="EMAIL *"
                        required
                        id="email_id"
                        value={formData.email_id}
                        onChange={handleInputChange}
                        // error={error.email_id}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.email_id && renderErrorMessage(error.email_id)}
                      {/* <InputField
                        required={true}
                        type="email"
                        id="email_id"
                        label="EMAIL"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={handleInputChange}
                        value={formData.email_id}
                        name="email_id"
                        error={error.email_id}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6 col-lg-12">
                    <div className="field-box w-100">
                      <input
                        className="phone homepageFirstDescription"
                        type="number"
                        name="contact_number"
                        onkeypress="return onlyNumberKey(event)"
                        placeholder="CONTACT NUMBER *"
                        // maxLength={12}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 12))
                        }
                        required
                        id="contact_number"
                        value={formData.contact_number}
                        onChange={handleInputChange}
                        // error={error.contact_number}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.contact_number &&
                        renderErrorMessage(error.contact_number)}
                      {/* <InputField
                        required={true}
                        type="number"
                        id="contact_number"
                        label="CONTACT NUMBER"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={handleInputChange}
                        value={formData.contact_number}
                        name="contact_number"
                        error={error.contact_number}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6 col-lg-12 desktopcontactinputs">
                    <div className="field-box w-100">
                      {/* <select
                        onChange={(e) => {
                          
                          setFullName(e.target.value);
                          State.getStatesOfCountry("IN").forEach((key) => {
                            if (key.name == e.target.value) {
                              setSelectState(key.isoCode);
                            }
                          });
                        }}
                      >
                        <option value="STATE">STATE </option>
                        {
                        {State.getStatesOfCountry("IN").map((e, key) => {
                          return (
                            <option value={e.name} name={e.state} key={key}>
                              {e.name}
                            </option>
                          );
                        })}
                      </select>
                      {error.state && renderErrorMessage(error.state)} */}
                      {/* <GlobalDropDown
                        required={true}
                        id="state"
                        label="STATE*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12"
                        onChange={handleInputChange}
                        value={formData.state}
                        option={State.getStatesOfCountry("IN")}
                        // option = {state}
                        // option={State.getStatesOfCountry(formData.country)}
                        type="State"
                        // error={error.state}
                        // onBlur={onBlur}
                        // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                      <Select
                        // ref={selectedstatevalue}
                        required={true}
                        id="state"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        type="State"
                        name="state"
                        className="col-12 homepageFirstDescription"
                        styles={colourStyles}
                        value={formData.state}
                        // defaultValue={genderOption}
                        // onChange={handleInputChange}
                        onChange={(e) => {
                          // setGender(e.value);
                          //
                          setFormData((user) => {
                            return { ...user, state: e };
                          });
                          // setSelectedState(e.value);
                          newStateOptionfunc(e.value);
                          cityInput.current.setValue("");
                          // setFormData((user) => {
                          //   return { ...user, state_name: e.label };
                          // });
                        }}
                        options={newStateOptions}
                        // options={Country.getAllCountries()}
                        onBlur={onBlur}
                        placeholder="STATE *"
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.state && renderErrorMessage(error.state)}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6 col-lg-12 desktopcontactinputs">
                    <div className="field-box w-100">
                      {/* <select
                        onChange={(e) => {
                          
                          setSelectCity(e.target.value);
                        }}
                      >
                        <option value="STATE">CITY </option>
                        {
                        {City.getCitiesOfState("IN", selectState).map(
                          (e, key) => {
                            return (
                              <option value={e.city} key={key}>
                                {e.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                      {error.city && renderErrorMessage(error.city)} */}
                      {/* <GlobalDropDown
                        required={true}
                        id="city"
                        label="City*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="city"
                        className="col-12"
                        onChange={handleInputChange}
                        value={formData.city}
                        option={City.getCitiesOfState("IN", formData.state)}
                        // option = {state}
                        // option={State.getStatesOfCountry(formData.country)}
                        // type="State"
                        error={error.state}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}

                      <Select
                        ref={cityInput}
                        required={true}
                        id="city"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        type="City"
                        name="city"
                        className="col-12 homepageFirstDescription"
                        styles={colourStyles}
                        value={formData.city}
                        // defaultValue={genderOption}
                        // onChange={handleInputChange}

                        onChange={(e) => {
                          // setGender(e.value);
                          //
                          setFormData((user) => {
                            return { ...user, city: e };
                          });

                          // setFormData((user) => {
                          //   return { ...user, state_name: e.label };
                          // });
                        }}
                        options={newCityOptions}
                        // options={Country.getAllCountries()}
                        onBlur={onBlur}
                        placeholder="CITY *"
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.city && renderErrorMessage(error.city)}
                      {/* <GlobalDropDown
                        required={true}
                        id="city"
                        label="CITY*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="city"
                        className="col-12"
                        onChange={handleInputChange}
                        value={formData.city}
                        option={City.getCitiesOfState("IN", formData.state)}
                        type="State"
                        // error={error.city}
                        // onBlur={onBlur}
                        // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                      {/* {error.city && renderErrorMessage(error.city)} */}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6 col-lg-12 desktopcontactinputs">
                    <div className="field-box w-100">
                      {/* <select
                        onChange={(e) => {
                          setEntityType(e.target.value);
                          
                        }}
                      >
                        <option value="STATE">USER TYPE </option>
                        <option value="Mentor">Mentor </option>
                        <option value="Startup">Startup </option>
                        <option value="Cohort-Based Program Partner">
                          Cohort-Based Program Partner
                        </option>
                        <option value="Other">Other</option>
                      </select>
                      {error.user_type && renderErrorMessage(error.user_type)} */}

                      {/* <GlobalDropDown
                        required={true}
                        id="user_type"
                        label="USER TYPE*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="user_type"
                        className="col-12"
                        onChange={handleInputChange}
                        value={formData.user_type}
                        // option={State.getStatesOfCountry(formData.country)}
                        option={usertypeOptions}
                        // type="State"
                        // error={error.user_type}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                      <Select
                        required={true}
                        id="user_type"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        // type="City"
                        name="user_type"
                        className="col-12 homepageFirstDescription"
                        styles={colourStyles}
                        value={formData.user_type}
                        // defaultValue={genderOption}
                        // onChange={handleInputChange}

                        onChange={(e) => {
                          // setGender(e.value);
                          //
                          setFormData((user) => {
                            return { ...user, user_type: e };
                          });

                          // setFormData((user) => {
                          //   return { ...user, state_name: e.label };
                          // });
                        }}
                        options={usertypeOptions}
                        // options={Country.getAllCountries()}
                        onBlur={onBlur}
                        placeholder="USER TYPE *"
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.user_type && renderErrorMessage(error.user_type)}
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 desktopcontactinputs">
                    <div className="field-box w-100">
                      {/* <GlobalDropDown
                        required={true}
                        id="query_type"
                        label="QUERY TYPE*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="query_type"
                        className="col-12"
                        onChange={handleInputChange}
                        value={formData.query_type}
                        // option={State.getStatesOfCountry(formData.country)}
                        option={queryOptions}
                        // type="State"
                        // error={error.user_type}
                        onBlur={onBlur}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      /> */}
                      <Select
                        required={true}
                        id="query_type"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        // type="City"
                        name="query_type"
                        className="col-12 homepageFirstDescription"
                        styles={colourStyles}
                        value={formData.query_type}
                        // defaultValue={genderOption}
                        // onChange={handleInputChange}

                        onChange={(e) => {
                          // setGender(e.value);
                          //
                          setFormData((user) => {
                            return { ...user, query_type: e };
                          });

                          // setFormData((user) => {
                          //   return { ...user, state_name: e.label };
                          // });
                        }}
                        options={queryOptions}
                        // options={Country.getAllCountries()}
                        onBlur={onBlur}
                        placeholder="QUERY TYPE *"
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                      />
                      {error.query_type && renderErrorMessage(error.query_type)}
                      {/* <select
                      
                        onChange={(e) => {
                          setButtonText(e.target.value);
                          
                         
                        }}
                      >
                        <option  value="QUERY">QUERY TYPE </option>
                        <option value="TECHNICAL ISSUE">
                          TECHNICAL ISSUE{" "}
                        </option>
                        <option value="APPLICATION ISSUE">
                          APPLICATION ISSUE
                        </option>
                        <option value="ISSUE WITH SPECIFIC MENTOR OR STARTUP">
                          ISSUE WITH SPECIFIC MENTOR OR STARTUP
                        </option>
                        <option value="NON-RESPONSE TO CONNECTION REQUEST">
                          NON-RESPONSE TO CONNECTION REQUEST
                        </option>
                        <option value="ISSUE WITH COHORT-BASED PROGRAM">
                          ISSUE WITH COHORT-BASED PROGRAM
                        </option>
                        <option value="FEEDBACK TO PROGRAM">
                          FEEDBACK TO PROGRAM
                        </option>
                        <option value="OTHER">OTHER</option>
                      </select>
                      {error.query_type && renderErrorMessage(error.query_type)} */}
                    </div>
                    {/* banner btn */}
                    {/* <div className="header-cart-box-banner-btn position-relative d-inline-block w-100">
                      <div className="tp-caption cart-btn position-relative">
                        <div className="field-box w-100">
                          <input
                            type="button"
                            name="QUERY TYPE "
                            value={buttonText}
                            defaultValue="QUERY TYPE  "
                            style={{ textAlign: "left" }}
                          />
                          {error.query_type &&
                            renderErrorMessage(error.query_type)}
                          <div className="contact-dropdown-btn">
                            <p className="contact-btn">
                              <a
                                ref={paragraphOption}
                                onClick={(e) => {
                                  
                                    paragraphOption.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption.current.innerHTML
                                  );
                                }}
                              >
                                TECHNICAL ISSUE
                              </a>
                            </p>

                            <p className="contact-btn">
                              <a
                                ref={paragraphOption2}
                                onClick={(e) => {
                                  
                                    paragraphOption2.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption2.current.innerHTML
                                  );
                                }}
                              >
                                APPLICATION ISSUE
                              </a>
                            </p>

                            <p className="contact-btn">
                              <a
                                ref={paragraphOption3}
                                onClick={(e) => {
                                  
                                    paragraphOption3.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption3.current.innerHTML
                                  );
                                }}
                              >
                                ISSUE WITH SPECIFIC MENTOR OR STARTUP
                              </a>
                            </p>

                            <p className="contact-btn">
                              <a
                                ref={paragraphOption4}
                                onClick={(e) => {
                                  
                                    paragraphOption4.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption4.current.innerHTML
                                  );
                                }}
                              >
                                NON-RESPONSE TO CONNECTION REQUEST
                              </a>
                            </p>

                            <p className="contact-btn">
                              <a
                                ref={paragraphOption5}
                                onClick={(e) => {
                                  
                                    paragraphOption5.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption5.current.innerHTML
                                  );
                                }}
                              >
                                ISSUE WITH COHORT-BASED PROGRAM
                              </a>
                            </p>

                            <p className="contact-btn">
                              <a
                                ref={paragraphOption6}
                                onClick={(e) => {
                                  
                                    paragraphOption6.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption6.current.innerHTML
                                  );
                                }}
                              >
                                FEEDBACK TO PROGRAM
                              </a>
                            </p>
                            <p className="contact-btn">
                              <a
                                ref={paragraphOption7}
                                onClick={(e) => {
                                  
                                    paragraphOption7.current.innerHTML
                                  );
                                  setButtonText(
                                    paragraphOption7.current.innerHTML
                                  );
                                }}
                              >
                                OTHER
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* <div className="col-md-4 col-sm-12 col-lg-4">
                <img
                  src="assets/images/contact-img.png"
                  style={{ height: 640 }}
                />
              </div> */}
              {/* <div class="col-md-1 col-sm-12 col-lg-1"> </div> */}
              {/*<div className="row">*/}
              {/* <div class="col-md-1 col-sm-12 col-lg-1"> </div> */}
              <div className="col-md-12 col-lg-12">
                <div className="field-box w-100">
                  <textarea
                    className="contact_message homepageFirstDescription"
                    name="message"
                    placeholder="QUERY DESCRIPTION*"
                    required
                    defaultValue={""}
                    id="message"
                    value={formData.message}
                    // onChange={handleInputChange}
                    onChange={(e, name) => {
                      const value = e.target.value;

                      const newerData = value.replace(/[ ]{2,}/gi, " ");
                      if (
                        newerData.split(" ").length <= 251 &&
                        testWordLimit(newerData) < 251
                      ) {
                        handleInputChange(e, name);
                        setFormData((user) => {
                          return { ...user, message: newerData };
                        });
                      }

                      setWordlimit(newerData);
                    }}
                    // error={error.message}
                    onBlur={onBlur}
                    hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                  />
                  {error.message && renderErrorMessage(error.message)}

                  <div
                    className="wordCounter wordcounterincontactpage"
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      marginTop: "-10px",
                      marginBottom: "7px",
                    }}
                  >
                    Word Count:{" "}
                    {formData.message?.length === 0
                      ? 0
                      : wordLimit?.length === 0
                      ? 0
                      : formData.message
                          ?.replace(/(^\s*)|(\s*$)/gi, "")
                          ?.replace(/[ ]{2,}/gi, " ")
                          ?.split(" ")?.length}{" "}
                    / 250
                  </div>
                  {errorVisible7 ? renderErrorMessage(errorMessagePurpose) : ""}
                  {/* {error.message && renderErrorMessage(error.message)} */}
                  {/* <InputField
                      required={false}
                      id="message"
                      label="QUERY DESCRIPTION"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="message"
                      className="col-12"
                      multiline
                      rows={6}
                      maxRows={6}
                      onChange={handleInputChange}
                      value={formData.message}
                      error={error.message}
                      onBlur={onBlur}
                      hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                    /> */}
                </div>
                <div>
                  <div className="field-btn w-100 ">
                    <div className="newuserTooltip">
                      <Button
                        id="submit"
                        style={{ cursor: "pointer" }}
                        className="homepageFirstDescription"
                        onClick={submitContactForm}
                      >
                        {/* {t('Submit')} */}
                        Submit
                      </Button>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{ left: "46px", top: "40px", width: "168px" }}
                      >
                        Click to Submit Query
                      </span>
                    </div>
                    {/* <div className="field-btn w-100">
                    <input
                      // type="submit"
                      className="contact-submit top-btn"
                      id="submit"
                      defaultValue="SUBMIT"
                      onClick={submitContactForm}
                      style={{ cursor: "pointer" }}
                    />
                  </div> */}
                  </div>
                </div>
              </div>
              {/* <div class="col-md-1 col-sm-12 col-lg-1"> </div> */}
              {/*</div>*/}
            </div>
          </form>
          <div className="row">
            {/* <div class="col-md-1 col-sm-12 col-lg-1"> </div> */}
            <div className="col-md-8 col-lg-8">
              <div className="quick-info">
                <p className="homepageFirstDescription">
                  Toll Free Number: <a href="tel:1800115565">1800115565 </a>•
                  Email:{" "}
                  <a href="mailto:startup.support@investindia.org.in">startup.support@investindia.org.in</a>{" "}
                </p>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="formgraphicdivcontact"></div>
    </section>
  );
}

const mapStateToProps = (state) => {
  //
  return {
    // contactSubmitData: state.contactSubmitReducer.contactSubmitData.data,
  };
};

export default connect(mapStateToProps, {
  contactSubmitData,
})(withRouter(ContactUs));
